
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/herkunft/ortschaften",
      function () {
        return require("private-next-pages/herkunft/ortschaften.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/herkunft/ortschaften"])
      });
    }
  